import * as React from "react";
import { Offer } from "./Cruise";
import * as style from "./Cruise.style";
import { Helmet } from "react-helmet";
import bacheloretteSandbar from "../../../public/assets/bachelorette-boat-cruise-sandbar.jpeg";

const FloatillaContent: React.FC = () => {
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="The Floatilla - Combine the Octolounge and the Kraken for the ultimate on-the-water experience for groups up to 26 people. Book Now!"
        />
        <title>The Floatilla - Ultimate Boat Rental Experience Dewey Beach</title>
      </Helmet>
      <div className={style.subHeader}>Description:</div>
      <div className={style.details}>
        Can't pick just one boat? Choose both and get the ultimate on-the-water
        experience with the Octolounge and the Kraken—truly the best of both
        worlds for groups of up to 26 people.
      </div>
      <div className={style.details}>
        With two experienced captains dedicated to your group, you can customize
        the day however you'd like. Anchor up, tie the boats together, and
        create one massive double-boat float. Roll out the mat, set up the
        inflatable dock, and turn the bay into your own private hangout for an
        unforgettable day on the water.
      </div>
    </>
  );
};

const Floatilla: React.FC = () => {
  return (
    <Offer
      title="The Floatilla"
      description="Up to 26 Guests &bull; All Ages &bull; Two Boats, Two Captains"
      imageSrc={bacheloretteSandbar}
      imageAlt="The Floatilla - Octolounge and Kraken Combo"
      children={<FloatillaContent />}
    />
  );
};

Floatilla.displayName = "Floatilla";
export { Floatilla };
